import { useEffect, useState, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { Box, Grid, MenuItem, TextField, Paper } from "@material-ui/core";

import { CustomizedSearch } from "../../components/custom/CustomizedSearch";
import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { useStyles } from "../../shared/styles/useStyles";
import { PqrsTable } from "../../components/correspondence-module/pqrs/PqrsTable";
import { InternalCorrespondenceStatus } from "../../enums/enums";
import { CustomizedWindow } from "../../components/custom/CustomizedWindow";
import { AppState } from "../../redux/reducers/rootReducer";
import { uiCloseModalAdd } from "../../redux/actions/uiActions";
import { setActiveCorrespondence } from "../../redux/actions/correspondenceActions";
import { PqrsDetails } from "../../components/correspondence-module/pqrs/PqrsDetails";
import { arraySearch } from "../../redux/actions/searchActions";
import { verifyFilterValues } from "../../helpers/validateFilter";

export const PqrsScreen = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [values, setValues] = useState({ trafficLight: 0, state: 0, inputType: 0 });
  const { modalAddOpen } = useSelector((state: AppState) => state.ui);
  const { data } = useSelector((state: AppState) => state.search);
  const { correspondence, paramResponseTime, paramsProcedure  } = useSelector(
      (state: AppState) => state.correspondence
  );
  const pqrs = useMemo(() => correspondence.filter((el) => el.answeredDate === null), [correspondence]);
  const { activeCorrespondence } = useSelector((state: AppState) => state.correspondence);

  const filteredPqrs = useMemo(() => {
    const { state, trafficLight } = values;

    const result = state !== 0 || trafficLight !== 0
        ? pqrs.filter((pqr) => {
          const isValid = verifyFilterValues(
              pqr,
              paramResponseTime,
              null,
              String(state),
              trafficLight
          );
          return isValid;
        })
        : pqrs;

    return result;
  }, [values, pqrs, paramResponseTime]);

  useEffect(() => {
    let filteredData = [...pqrs];

    if (values.trafficLight !== 0) {
      filteredData = filteredData.filter((pqr) =>
          verifyFilterValues(pqr, paramResponseTime, null, undefined, values.trafficLight, undefined, paramsProcedure)
      );
    }

    if (values.state !== 0) {
      filteredData = filteredData.filter((pqr) =>
          verifyFilterValues(pqr, paramResponseTime, null, String(values.state))
      );
    }

    dispatch(arraySearch(filteredData));
  }, [values, pqrs, paramResponseTime, dispatch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;



    setValues((prev) => {
      const updatedValues = {
        ...prev,
        [name]: isNaN(Number(value)) ? value : Number(value), // Convertir a número solo si es posible
        ...(name === "trafficLight" && { state: value !== "0" ? 0 : prev.state }),
        ...(name === "state" && { trafficLight: value !== "0" ? 0 : prev.trafficLight }),
      };


      return updatedValues;
    });
  };

  const onDeny = () => {
    dispatch(uiCloseModalAdd());
    dispatch(setActiveCorrespondence(null));
  };

  return (
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <Paper square className={classes.paper}>
          <Box mb={3} p={3} fontSize={20}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <label className={classes.typography}>
                  <FormattedMessage id="TrafficLight" />:
                </label>
                <TextField
                    name="trafficLight"
                    variant="outlined"
                    value={values.trafficLight || 0}
                    onChange={(event) => {

                      handleChange(event);
                    }}
                    select
                    className={classes.myTextFieldRoot}
                    size="small"
                    disabled={values.state !== 0}
                >
                  <MenuItem value={0}>
                    <FormattedMessage id="All" />
                  </MenuItem>
                  <MenuItem value={1}>
                    <FormattedMessage id="TrafficLightOpt1" />
                  </MenuItem>
                  <MenuItem value={2}>
                    <FormattedMessage id="TrafficLightOpt2" />
                  </MenuItem>
                  <MenuItem value={3}>
                    <FormattedMessage id="TrafficLightOpt3" />
                  </MenuItem>
                  <MenuItem value={4}>
                    <FormattedMessage id="TrafficLightOpt4" />
                  </MenuItem>
                  <MenuItem value={5}>
                    <FormattedMessage id="TrafficLightOpt5" />
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <label className={classes.typography}>
                  <FormattedMessage id="State" />:
                </label>
                <TextField
                    name="state"
                    variant="outlined"
                    value={values.state || "0"}
                    onChange={(event) => {

                      handleChange(event);
                    }}
                    select
                    className={classes.myTextFieldRoot}
                    disabled={values.trafficLight !== 0}
                    size="small"
                >
                  <MenuItem value="0">
                    <FormattedMessage id="All" />
                  </MenuItem>
                  <MenuItem
                      value={InternalCorrespondenceStatus.RESPONSE_ISSUED_ONTIME}
                  >
                    <FormattedMessage id="ResponseIssuedOnTime" />
                  </MenuItem>
                  <MenuItem
                      value={InternalCorrespondenceStatus.EXTEMPORANEOUS_RESPONSE}
                  >
                    <FormattedMessage id="ExtemporaneousResponse" />
                  </MenuItem>
                  <MenuItem value={InternalCorrespondenceStatus.UNANSWERED}>
                    <FormattedMessage id="Unanswered" />
                  </MenuItem>
                  <MenuItem
                      value={InternalCorrespondenceStatus.NO_ANSWER_REQUIRED}
                  >
                    <FormattedMessage id="NoAnswerRequired" />
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={5}>
                <Box sx={{ marginTop: "30px" }}>
                  <CustomizedSearch
                      data={filteredPqrs}
                  />
                </Box>
              </Grid>
            </Grid>
            <Box mt={2}>
              <PqrsTable />
            </Box>

            <CustomizedWindow
                open={modalAddOpen}
                content={<PqrsDetails />}
                onDeny={onDeny}
                title={`${intl.formatMessage({ id: "Settled" })} No. ${activeCorrespondence?.id}`}
            />
          </Box>
        </Paper>
      </AppAnimate>
  );
};
